class OfferBox extends HTMLElement {
    constructor() {
        super();

        this.cartAmount = this.dataset.cartAmount
            ? parseInt(this.dataset.cartAmount)
            : 0;;
        this.numberOffer = this.dataset.numberOffer
            ? parseInt(this.dataset.numberOffer)
            : 0;
        this.totalOffer = this.dataset.totalOffer
            ? parseInt(this.dataset.totalOffer)
            : 0;

        this.progressItems = this.querySelectorAll(
            ".banner__promotion-progress-item"
        );
        this.promotionProgress = this.querySelector(
            ".banner__promotion-progress"
        );

        this.widthOffer = 0;

        this.initProgress();

        this.initEvent();
    }

    initProgress() {
        if (this.totalOffer && this.numberOffer) {
            for (let i = 0; i < this.progressItems.length; i++) {
                if (i < this.numberOffer) {
                    this.progressItems[i].classList.add("active");
                } else {
                    this.progressItems[i].classList.remove("active");
                }
            }
        } else {
            for (let i = 0; i < this.progressItems.length; i++) {
                this.progressItems[i].classList.remove("active");
            }
        }

        this.setWidth();
    }

    initEvent() {
        const constantMock = window.fetch;
        const that = this;
        window.fetch = function () {
            const url = arguments[0];

            if (
                url.includes("cart") &&
                (url.includes("add") ||
                    url.includes("update") ||
                    url.includes("change"))
            ) {
                return constantMock
                    .apply(this, arguments)
                    .finally(() => that.updateProgress());
            }

            return constantMock.apply(this, arguments);
        };
    }

    updateProgress() {
        fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
                this.cartAmount = data.original_total_price;
                let count = 0;

                this.progressItems.forEach((item) => {
                    const progressAmount = parseInt(item.dataset.amount);

                    if (progressAmount <= this.cartAmount) {
                        count++;
                    }
                });

                this.numberOffer = count;

                this.initProgress();
            });
    }

    setWidth() {
        // if (this.progressItems.length === 0) return;

        let progressBarWidth = this.promotionProgress.offsetWidth;

        let firstItemOffset = this.numberOffer === 0 ? 0 : this.progressItems[0].offsetLeft; // First item's left position
        let lastItemOffset =
            this.progressItems[this.progressItems.length - 1].offsetLeft; // Last item's left position

        let previousAmount = 0;
        let previousPosition = firstItemOffset; // Start at first item position
        let nextAmount = parseInt(this.progressItems[0].dataset.amount);
        let nextPosition = firstItemOffset;

        for (let i = 0; i < this.progressItems.length; i++) {
            let progressAmount = parseInt(this.progressItems[i].dataset.amount);
            let progressOffset = this.progressItems[i].offsetLeft; // Get exact pixel position

            if (this.cartAmount < progressAmount) {
                nextAmount = progressAmount;
                nextPosition = progressOffset;
                break;
            }

            previousAmount = progressAmount;
            previousPosition = progressOffset;
        }

        // Interpolate width based on pixel positions
        this.widthOffer =
            previousPosition +
            ((this.cartAmount - previousAmount) / (nextAmount - previousAmount)) *
            (nextPosition - previousPosition);

        // Convert to pixels relative to the progress bar width
        let widthPixels = Math.min(this.widthOffer, progressBarWidth);

        this.promotionProgress.style.setProperty(
            "--progress-bar-width",
            `${widthPixels}px`
        );
    }
}

if (!customElements.get("offer-box")) {
    customElements.define("offer-box", OfferBox);
}